<template>
  <div class="capa">
    <Binarios />
    <div class="texto">
      <!-- <h1><span class="azul">ENA</span><span class="laranja">TI</span></h1> -->
      <img src="@/assets/imgs/layout/Ativo 1.png" class="mb-4 img-fluid">
    </div>
    <div class="imagem">
      <img src="@/assets/imgs/layout/Ativo 2.png" alt="Mapa estilizado do Estado de Goiás, com destaque para a região Oeste" />

    </div>
  </div>
</template>

<script>
import Binarios from "./Binarios";

export default {
  components: {
    Binarios,
  },
};
</script>

<style scoped>
.laranja {
  background-image: linear-gradient(-20deg, #fc6076 0%, #ff9a44 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.azul {
  background-image: linear-gradient(
    132.6deg,
    rgba(71, 139, 214, 1) 23.3%,
    rgba(37, 216, 211, 1) 84.7%
  );
  -webkit-background-clip: text;
}

#oeste {
  fill: #ff9a44;
}

#goias {
  fill: none;
  fill: none;
  stroke: #80cde5;
  stroke-width: 7px;
  stroke-linejoin: round;
}

body {
  /* background: linear-gradient(135deg, #432400 0%, #000 25%), gray repeating-linear-gradient(-135deg, red 0%, #000 55%); */

  /* background-image: 
  linear-gradient(135deg, #432400 0%, #000 25%); */

  background-image: linear-gradient(135deg, #ff6b00 0%, #fff 25%);

  background-attachment: fixed;
}

body > header {
  padding-bottom: 300px;
  color: #fff;
}

.capa {
  display: flex;
  margin: 100px 0px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 40px 0px;
  position: relative;
  /*background: url('./assets/imgs/layout/binarios.png');
  background-repeat: no-repeat;
  background-position: center right;*/
}

.texto p{
  margin-top: 3rem; display: block; font-weight: 100; font-size: 1.75rem;
}

.capa > div {
  flex: 1 1 50%;
  z-index: 2;
}

.capa > .imagem {
  display: flex;
  justify-content: flex-end;
}

.capa > .imagem img,
.capa > .imagem svg {
  max-width: 500px;
  width: 100%;
  /*animation: bounce 1s infinite;*/
}

.capa h1 {
  font-family: "Barlow";
  font-style: normal;
  font-weight: 800;
  font-size: 60px;
  line-height: 100.5%;
  color: var(--corTexto);
}

.capa h2 {
  font-family: "Barlow";
  font-style: normal;
  font-weight: 500;
  font-size: 50px;
  line-height: 100.5%;
  /*color: var(--corSecundaria);*/
}

@media screen and (max-width: 900px) {
  .capa {
    padding: 50px;
  }
  .capa > div {
    flex: 1 1 100%;
    justify-content: center;
    text-align: center;
  }
}

@keyframes bounce {
  0% {
    transform: translate3d(0px, 0px, 0);
  }
  50% {
    transform: translate3d(-8px, 8px, 8px);
  }
  100% {
    transform: translate3d(0px, 0px, 0);
  }
}
</style>
